import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Translation from '../../../../v2/lang/Translation';
import {getStart} from '../../../../v2/selectors/selectors';
import replaceHTMLEntityWithSymbol from '../../../../v2/utils/replace-html-entity-with-symbol';

export function MultibancoPaymentInformation(props) {
  return (
    <div className="MultibancoPaymentInformation">
      <p>
        <Translation>checkout.complete.multibanco.heading.line1.text</Translation>
        <br />
        <Translation>checkout.complete.multibanco.heading.line2.text</Translation>
        <br />
        <ul>
          <li>
            <Translation>checkout.complete.multibanco.heading.subline1.text</Translation>
          </li>
          <li>
            <Translation>checkout.complete.multibanco.heading.subline2.text</Translation>
          </li>
          <li>
            <Translation>checkout.complete.multibanco.heading.subline3.text</Translation>
          </li>
        </ul>
        <Translation>checkout.complete.multibanco.heading.line3.text</Translation>
      </p>
      <div data-cs-mask>
        <strong>
          <Translation>checkout.complete.multibanco.reference.text</Translation>
        </strong>
        :
        {' '}
        {props.multibancoReference}
      </div>
      <div>
        <strong>
          <Translation>checkout.complete.multibanco.entity.text</Translation>
        </strong>
        :
        {' '}
        {props.multibancoEntity}
      </div>
      <div>
        <strong>
          <Translation>checkout.complete.multibanco.amount.text</Translation>
        </strong>
        :
        {' '}
        {replaceHTMLEntityWithSymbol(props.orderAmount)}
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  multibancoReference: getStart(state).multibancoPaymentDetails.multibancoReference.replace(/\+/g, ' '),
  multibancoEntity: getStart(state).multibancoPaymentDetails.multibancoEntity,
  orderAmount: getStart(state).displayOrderTotal,
});

MultibancoPaymentInformation.propTypes = {
  multibancoReference: PropTypes.string.isRequired,
  multibancoEntity: PropTypes.string.isRequired,
  orderAmount: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
)(MultibancoPaymentInformation);
